import React, { Component } from "react";

import { Heading3 } from "../Heading3";
import { Popup } from "../Popup";
import * as styles from "./HotkeysHelp.scss";
import { IHotkey } from "./IHotkey";

export interface IHotkeysHelpProps {
    hotkeys: IHotkey[];
    visible: boolean;
    onClose: () => void;
}

export class HotkeysHelp extends Component<IHotkeysHelpProps> {
    public render() {
        const { hotkeys, visible, onClose } = this.props;
        return (
            <Popup
                className={styles["hotkeys-help"]}
                visible={visible}
                onClose={onClose}
            >
                <Heading3>Keyboard Shortcuts</Heading3>
                <ul>
                    {hotkeys.map(({ label, code }) => (
                        <li key={code}>
                            <div className={styles.code}>{code}</div>
                            <div className={styles.label}>{label}</div>
                        </li>
                    ))}
                </ul>
            </Popup>
        );
    }
}
